export enum MetafieldKeys {
  Id = 'id',
  Handle = 'handle',
  Value = 'value',
}
